/** Cliente de la API. La sesión va en cookie, así que no hay tokens en el navegador. */

export class ErrorApi extends Error {
  constructor(
    public estado: number,
    mensaje: string,
    /** Lo que acompaña al error: pegas que faltan, ficha duplicada, etc. */
    public datos: Record<string, unknown> = {},
  ) {
    super(mensaje)
  }

  /** Lista de cosas que faltan para poder avanzar. */
  get pegas(): string[] {
    return Array.isArray(this.datos.pegas) ? (this.datos.pegas as string[]) : []
  }
}

function leerCookie(nombre: string): string {
  const parte = document.cookie.split('; ').find((c) => c.startsWith(`${nombre}=`))
  return parte ? decodeURIComponent(parte.slice(nombre.length + 1)) : ''
}

type Opciones = {
  metodo?: 'GET' | 'POST' | 'PATCH' | 'DELETE'
  cuerpo?: unknown
}

export async function api<T>(ruta: string, { metodo = 'GET', cuerpo }: Opciones = {}): Promise<T> {
  const cabeceras: Record<string, string> = {}
  if (cuerpo !== undefined) cabeceras['Content-Type'] = 'application/json'

  if (metodo !== 'GET') {
    let csrf = leerCookie('codoh_csrf')
    if (!csrf) {
      // Sin cookie (primera visita o sesión limpiada): una lectura la entrega.
      await fetch('/api/salud', { credentials: 'same-origin' })
      csrf = leerCookie('codoh_csrf')
    }
    cabeceras['X-CSRF-Token'] = csrf
  }

  const respuesta = await fetch(ruta, {
    method: metodo,
    headers: cabeceras,
    body: cuerpo === undefined ? undefined : JSON.stringify(cuerpo),
    credentials: 'same-origin',
  })

  if (respuesta.status === 204) return undefined as T

  const datos = (await respuesta.json().catch(() => ({}))) as Record<string, unknown>

  if (!respuesta.ok) {
    throw new ErrorApi(respuesta.status, (datos.error as string) ?? 'Error inesperado', datos)
  }

  return datos as T
}
